/*
 * InSight Analytics Solutions Limited
 * https://fieldpro.onyxinsight.com/
 *
 * Copyright (c) 2021 Onyx InSight Field Pro.
 * This file is licensed to InSight Analytics Solutions Limited
 */
import { recalculateTopSeverityForSections } from '../../../utils/recalculateTopSeverity';
const initialState = {
  reportTree: [],
  severityDetailList: [],
  issueSummary: [],
  reportTaskData: [],
  reportSectionTaskData: null,
  preSignedUrl: null,
  checklistTree: [],
  reportHeaderData: '',
  GetReportInformationLoading: false,
  GetReportInformationCastrolData: [],
  GetCastrolPdiTemplateRecordsData: [],
  GetOnyxUkTemplateRecordsData: [],
  GetOnyxUkContactDetailsByReportIdData: [],
  //
  GetCastrolPdiTankTableDetailsData: [],
  GetCastrolPdiActionTableDetailsData: [],
  GetCastrolPdiTankAdditionalDetailsData: [],
  GetCastrolPdiAssesmentDetails: [],
  //
  reportDLdata: '',
  temperatureTrending: null,
  wpocontent: '',
  panelCheck: null,
  ReportViewerDeleteStatus: '',
  S3Url: null,
  serialNumber: '',
  castrolcomment: null,
};

const reportViewerReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case 'REPORT_TREE':
      return {
        ...state,
        reportTree: action.value,
      };
    case 'SEVERITY_DETAIL_LIST':
      return {
        ...state,
        severityDetailList: action.value,
      };
    case 'REPORT_ISSUE_SUMMARY':
      return {
        ...state,
        issueSummary: action.value,
      };
    case 'REPORT_SECTION_TASK_DATA':
      return {
        ...state,
        reportSectionTaskData: action.value.length === 0 ? [1] : action.value,
      };
    case 'REPORT_TASK_DATA':
      return {
        ...state,
        reportTaskData: action.value,
      };
    case 'PRESIGNEDURL':
      return {
        ...state,
        preSignedUrl: action.value,
      };
    case 'CHECKLIST_TREE':
      return {
        ...state,
        checklistTree: action.value,
      };
    case 'REPORT_HEADER_DATA':
      return {
        ...state,
        reportHeaderData: action.value,
      };
    case 'GET_REPORT_INFORMATION_LOADING':
      return {
        ...state,
        GetReportInformationLoading: action.value,
      };
    case 'GET_REPORT_INFORMATION_CASTROL_DATA':
      return {
        ...state,
        GetReportInformationCastrolData: action.value,
      };
    case 'GET_CASTROL_PDI_TEMPLATE_RECORDS_DATA':
      return {
        ...state,
        GetCastrolPdiTemplateRecordsData: action.value,
      };
    case 'GET_ONYX_UK_TEMPLATE_RECORDS_DATA':
      return {
        ...state,
        GetOnyxUkTemplateRecordsData: action.value,
      };
    case 'GET_ONYX_UK_CONTACT_DETAILS_BY_REPORT_ID_DATA':
      return {
        ...state,
        GetOnyxUkContactDetailsByReportIdData: action.value,
      };
    //
    case 'GET_CASTROL_PDI_TANK_TABLE_DETAILS_DATA':
      return {
        ...state,
        GetCastrolPdiTankTableDetailsData: action.value,
      };
    case 'GET_CASTROL_PDI_ACTION_TABLE_DETAILS_DATA':
      return {
        ...state,
        GetCastrolPdiActionTableDetailsData: action.value,
      };
    case 'GET_CASTROL_PDI_TANK_ADDITIONAL_DETAILS_DATA':
      return {
        ...state,
        GetCastrolPdiTankAdditionalDetailsData: action.value,
      };
    case 'GET_CASTROL_PDI_ASSESMENT_DETAILS':
      return {
        ...state,
        GetCastrolPdiAssesmentDetails: action.value,
      };
    //
    case 'DELETE_REPORT_IN_REPORTVIEWER':
      return {
        ...state,
        ReportViewerDeleteStatus: action.value,
      };
    case 'CLEAR_DELETE_REPORT_IN_REPORTVIEWER':
      return {
        ...state,
        ReportViewerDeleteStatus: '',
      };
    case 'REPORT_DL_DATA':
      return {
        ...state,
        reportDLdata: action.value,
      };
    case 'TEMPERATURE_TRENDING_CHART':
      return {
        ...state,
        temperatureTrending: action.value,
      };
    case 'GET_WPO_CONTENT':
      return {
        ...state,
        wpocontent: action.value,
      };
    case 'GET_PANEL_CHECK':
      return {
        ...state,
        panelCheck: action.value,
      };
    case 'S3Url':
      return {
        ...state,
        S3Url: action.value,
      };
    case 'SERIAL_NUMBER':
      return {
        ...state,
        serialNumber: action.value,
      };
    case 'CASTROL_COMMENT':
      return {
        ...state,
        castrolcomment: action.value,
      };
    case 'RECALCULATE_TOP_SEVERITY':
      return {
        ...state,
        reportSectionTaskData: state.reportSectionTaskData
          ? recalculateTopSeverityForSections(state.reportSectionTaskData)
          : state.reportSectionTaskData,
      };
    default:
      return state;
  }
};

export default reportViewerReducer;
